<div class="row">
  <div class="col-xl-1 col-lg-1 hidden-md"></div>
  <div class="col-xl-10 col-lg-12 col-md-12 col-sm-12 col-xs-12">

    <div class="row">
        <div class="col-12">

            <div>
                <p>
                <h1>Cookie Notice</h1>
                <p>A cookie is a small piece of data (text file) that a website &ndash; when visited by a user &ndash; asks your browser to store on your device to remember information about you, such as your login information. On our Portal, these are third-party cookies, and they are set by our identity &amp; access provider. These are called third party cookies because they are set from a domain different than the domain of the Portal you are visiting.</p>
                <p>More specifically, we only use cookies for the following purposes:</p>
                <ul>
                    <li>Logging into the portal and session management.</li>
                </ul>
                <p>&nbsp;</p>
                <p>Below is a detailed list of the cookies we use on our Portal. We classify cookies in the following categories:
                </p>
                <ul>
                    <li style="color:#ff7900">Strictly Necessary Cookies</li>
                </ul>
                <p>&nbsp;</p>
                <h3><strong>Cookie List</strong></h3>
                <h4>Strictly Necessary Cookies</h4>
                <p>These cookies are necessary for the Portal to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as logging in to the Portal. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work.</p>
                <p>&nbsp;</p>
                <table id="cookie-policy" style="width: 85%; margin-left: auto; margin-right: auto;">
                    <tbody>
                        <tr class="rowfiller">
                            <th>
                                <p>Cookie Subgroup</p>
                            </th>
                            <th>
                                <p>Cookies</p>
                            </th>
                            <th>
                                <p>Cookies used</p>
                            </th>
                            <th>
                                <p>Life Span</p>
                            </th>
                        </tr>
                        <tr>
                            <td>
                                <p><strong>Okta.com</strong></p>
                            </td>
                            <td>
                                <p>Okta-oauth-nonce</p>
                            </td>
                            <td>
                                <p>Third Party</p>
                            </td>
                            <td>
                                <p>Session</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p><strong>Okta.com</strong></p>
                            </td>
                            <td>
                                <p>Okta-oauth-redirect-parms</p>
                            </td>
                            <td>
                                <p>Third Party</p>
                            </td>
                            <td>
                                <p>Session</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p><strong>Okta.com</strong></p>
                            </td>
                            <td>
                                <p>Okta-oauth-state</p>
                            </td>
                            <td>
                                <p>Third Party</p>
                            </td>
                            <td>
                                <p>Session</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <br /><br /><br /><br />

        </div>
    </div>

  </div>
</div>